import React, { useEffect } from "react";
import "../styles/FixedBg.scss"

const FixedBg= () => {

    // useEffect(() => {
    //     const setHeight = () => {
    //         const vh = window.innerHeight * 0.01;
    //         document.documentElement.style.setProperty('--vh', `${vh}px`);
    //     }
    //     setHeight();
    // });

    return (
        <div className="fixedBg">
            <div className="fixedBg__inner"></div>
        </div>
    )
}

export default FixedBg